import { render, staticRenderFns } from "./LiquidationList.vue?vue&type=template&id=ca164aae"
import script from "./LiquidationList.vue?vue&type=script&lang=js"
export * from "./LiquidationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports